import { getKeys, mapRecordToArray } from "@base/util/TypeUtil";

export interface IGlossyInfo {
  enabled: boolean;
  linkedArticle: string;
}

export const PowderCoatingCategories = {
  "Cat1": { articleId: "BESCHICHT_KAT1" },
  "Cat2": { articleId: "BESCHICHT_KAT2" },
  "Cat3": { articleId: "BESCHICHT_KAT3" }
}

export const VERSION_POWDER_COATING = 1;
export interface IPowderCoatingProduct {
  version: number;
  flag: boolean
  colors: string[];
}

export interface IPowderCoatingArticle {
  color: string | undefined;
}

export type PowderCoatingCategory = keyof typeof PowderCoatingCategories;

export interface IPowderColor {
  id: string;
  name: string;
  color: string;
}

function _fillId<K extends string, V extends { id: K }>(map: Record<K, Omit<V, "id">>): Record<K, V> {
  const ret: Record<K, V> = {} as any;
  const keys = getKeys(map);
  for (const k of keys) {
    const old: Omit<V, "id"> = map[k];
    const newItem = { ...old, id: k };
    ret[k] = newItem as any;
  }
  return ret;
}


function fillIdRecord<V>(): <T extends Record<string, Omit<V, "id">>>(obj: T) => Record<T extends Record<infer K, any> ? K : never, V> {
  return (obj) => _fillId(obj) as any;
}

const powderColorMap = fillIdRecord<IPowderColor>()({
  RAL3000: { name: "Feuerrot", color: "#a92228" },
  RAL5015: { name: "Himmelblau", color: "#2d75b0" },
  RAL7001: { name: "Silbergrau", color: "#8e969d" },
  RAL7004: { name: "Signalgrau", color: "#9b9b9b" },
  RAL7016: { name: "Anthrazitgrau", color: "#383e42" },
  RAL9004: { name: "Signalschwarz", color: "#2b2b2c" },
  RAL9016: { name: "Verkehrsweiß", color: "#f0f1ea" },
})

const powderColorArray = mapRecordToArray(powderColorMap, (p, id): IPowderColor => ({ ...p, id }))

export class PowderCoating {
  static DEFAULT_COLOR = "RAL7016";

  static getPowderColorMap(): Record<string, Omit<IPowderColor, "id">> {
    return powderColorMap;
  }

  static getPowderColorArray(): IPowderColor[] {
    return powderColorArray;
  }

  static getPowderCoating(index: number | undefined, global: IPowderCoatingProduct | undefined): string | undefined {
    if (!global?.flag || index === undefined || index >= (global?.colors?.length || 0))
      return undefined;
    return global.colors[index];
  }
}